import React from 'react'

import "./APStartCTAImageCard.css"

const APStartCTAImageCard = ({ imageSrc }) => {
  return (
    <img className="adoption-process-start-image-cards" src={imageSrc} alt="picture of pets"/>
  )
}

export default APStartCTAImageCard
